import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faCalendar } from '@fortawesome/free-regular-svg-icons';
import { NgbDate, NgbDatepicker } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Component({
  standalone: false,
  selector: 'app-time-picker',
  templateUrl: './time-picker.component.html',
  styleUrls: [ './time-picker.component.css' ]
})
export class TimePickerComponent implements OnInit, OnChanges {
  calIcon = faCalendar as IconProp;
  @Input() dateTimeString: string = moment().format('YYYY-MM-DDTHH:mm');
  @Input() timeModel: string = moment().format('HH:mm:ss');
  @Input() dateModel: string = moment().format('YYYY-MM-DD');
  @Input() disableTimePickers = false;
  @Input() minDate: string;
  @Output() result: EventEmitter<any> = new EventEmitter();

  ngOnInit(): void {
    this.result.emit(this.dateTimeString);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.dateTimeString) {
      this.dateModel = moment(changes.dateTimeString.currentValue).format('YYYY-MM-DD');
      this.timeModel = moment(changes.dateTimeString.currentValue).format('HH:mm:ss');
    }
  }

  onTimeChange(): void {
    if (this.timeModel) {
      this.dateTimeString = `${moment(this.dateTimeString)
        .format('YYYY-MM-DD')
        .concat('T')
        .concat(this.timeModel.substring(0, 5))}`;
      this.result.emit(this.dateTimeString);
    }
  }

  onDateChange(e: any): void {
    if (this.dateModel) {
      this.dateTimeString = `${this.dateModel.concat('T')}${moment(this.dateTimeString).format('HH:mm')}`;
      this.result.emit(this.dateTimeString);
    }
  }
}
